import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { DISTRIBUTION_RULE_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  data: FieldValues
}

const mutateCopyRule = async ({ data }: mutateProps) => {
  return await axiosAuth.post(
    `${DISTRIBUTION_RULE_API(data.communityId)}/copy`,
    data
  );
};

const useCopyRuleMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateCopyRule,
    ...queryParams,
  });

export default useCopyRuleMutation;
